(function () {
  const STORAGE_KEY = 'as-buy-more-bar-dismissed';
  let globalCartListenersAttached = false;

  function refreshAllBuyMoreBars() {
    document.querySelectorAll('[data-buy-more-bar]').forEach((el) => {
      if (el.isConnected && typeof el._buyMoreBarRefresh === 'function') {
        el._buyMoreBarRefresh();
      }
    });
  }

  function attachGlobalCartListeners() {
    if (globalCartListenersAttached) return;
    globalCartListenersAttached = true;
    const onCartChange = () => {
      refreshAllBuyMoreBars();
      scheduleInitAll();
    };
    const bind = () => {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, onCartChange);
        return true;
      }
      return false;
    };
    if (!bind()) {
      let tries = 0;
      const timer = setInterval(() => {
        if (bind() || tries > 50) clearInterval(timer);
        tries += 1;
      }, 100);
    }
    document.addEventListener('cart:refresh', onCartChange);
  }

  const ICONS = {
    start:
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    box:
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3 7.5 12 3l9 4.5M3 7.5v9L12 21l9-4.5v-9M3 7.5l9 4.5m0 0 9-4.5m-9 4.5V21" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    gift:
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    truck:
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3 6h11v10H3zM14 9h4l3 3v4h-7M7.5 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM17.5 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    diamond:
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 3h12l3 6-9 12L3 9l3-6zM3 9h18M9 3l-3 6 6 12M15 3l3 6-6 12" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" stroke-linecap="round"/></svg>',
    percent:
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 19 19 5M7.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM16.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    star:
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="m12 3 2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 17.8 6.2 20.9l1.1-6.5L2.6 9.8l6.5-.9L12 3Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
  };

  function getDismissed() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setDismissed(value) {
    try {
      if (value) sessionStorage.setItem(STORAGE_KEY, '1');
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* noop */
    }
  }

  function format(template, vars) {
    if (!template) return '';
    return template.replace(/\[\s*([\w_]+)\s*\]|\{\{\s*([\w_]+)\s*\}\}/g, function (_, bracketKey, curlyKey) {
      const key = bracketKey || curlyKey;
      return vars[key] != null ? String(vars[key]) : '';
    });
  }

  class BuyMoreBar {
    constructor(element) {
      this.element = element;
      this.messageEl = element.querySelector('[data-buy-more-bar-message]');
      this.progressEl = element.querySelector('[data-buy-more-bar-progress]');
      this.stepsEl = element.querySelector('[data-buy-more-bar-steps]');
      this.closeBtn = element.querySelector('[data-buy-more-bar-close]');

      const configEl = element.querySelector('[data-buy-more-bar-config]');
      try {
        this.config = configEl ? JSON.parse(configEl.textContent) : {};
      } catch (e) {
        console.warn('Buy more bar: invalid config JSON.', e);
        this.config = {};
      }

      this.qualifyingIds = Array.isArray(this.config.qualifyingIds) ? this.config.qualifyingIds : [];
      this.collectionHandle = this.config.collectionHandle || '';
      this.restrictToCollection = !!this.config.restrictToCollection;
      this._qualifyingIdsLoaded = !this.collectionHandle;
      this.tiers = (this.config.tiers || []).slice().sort((a, b) => (a.count || 0) - (b.count || 0));
      this.messages = this.config.messages || {};
      this.hideOnEmpty = element.dataset.hideOnEmpty === 'true';
      this.hideWhenUnlocked = element.dataset.hideWhenUnlocked === 'true';
      this.dismissible = element.dataset.dismissible === 'true';
      this.requireQualifying = element.dataset.requireQualifying === 'true';
      this.isFixedBar =
        !element.classList.contains('as-buy-more-bar--drawer') &&
        !element.classList.contains('as-buy-more-bar--cart') &&
        !element.classList.contains('as-buy-more-bar--inline');

      const excludedRaw = element.dataset.excludedFilters || '';
      this.excludedFilters = excludedRaw
        .split(',')
        .map((s) => s.trim().toLowerCase())
        .filter(Boolean);

      this.currentCount = 0;
      this.cartItemCount = 0;

      this.renderSteps();
      attachGlobalCartListeners();
      this.element._buyMoreBarRefresh = () => this.refresh();
      this.bindEvents();
      this.refresh();
    }

    isHiddenByFilter() {
      if (!this.excludedFilters.length) return false;
      let params;
      try {
        params = new URLSearchParams(window.location.search);
      } catch (e) {
        return false;
      }
      const keys = [];
      params.forEach((_, key) => keys.push(key.toLowerCase()));
      for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i];
        for (let j = 0; j < this.excludedFilters.length; j += 1) {
          const token = this.excludedFilters[j];
          if (key === token) return true;
          if (key.length > token.length && key.slice(-(token.length + 1)) === '.' + token) return true;
        }
      }
      return false;
    }

    bindEvents() {
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.dismiss());
      }

      if (this.excludedFilters.length) {
        if (!window.__bmbHistoryPatched) {
          const origPushState = history.pushState;
          const origReplaceState = history.replaceState;
          history.pushState = function () {
            const result = origPushState.apply(this, arguments);
            window.dispatchEvent(new Event('as-bmb:locationchange'));
            return result;
          };
          history.replaceState = function () {
            const result = origReplaceState.apply(this, arguments);
            window.dispatchEvent(new Event('as-bmb:locationchange'));
            return result;
          };
          window.addEventListener('popstate', () => {
            window.dispatchEvent(new Event('as-bmb:locationchange'));
          });
          window.__bmbHistoryPatched = true;
        }
        window.addEventListener('as-bmb:locationchange', () => this.update());
      }

      this.footerEl = null;
      this.footerObserver = null;
      this.isFooterVisible = false;
      if (this.isFixedBar) {
        this.footerEl = document.querySelector('footer') || document.querySelector('[class*="footer"]');
        if (this.footerEl) {
          this.footerObserver = new IntersectionObserver(
            (entries) => {
              this.isFooterVisible = entries[0].isIntersecting;
              if (this.isFooterVisible) {
                this.element.classList.add('is-hidden-by-footer');
                document.body.classList.remove('as-buy-more-bar-visible');
              } else {
                this.element.classList.remove('is-hidden-by-footer');
                if (this.element.classList.contains('is-visible')) {
                  document.body.classList.add('as-buy-more-bar-visible');
                }
              }
            },
            { threshold: 0 }
          );
          this.footerObserver.observe(this.footerEl);
        }
      }
    }

    renderSteps() {
      if (!this.stepsEl || !this.tiers.length) return;

      const maxTier = this.tiers[this.tiers.length - 1].count || 1;
      this.stepsEl.innerHTML = '';

      this.tiers.forEach((tier, index) => {
        const pct = maxTier === 0 ? 0 : Math.min(100, (tier.count / maxTier) * 100);
        const step = document.createElement('div');
        step.className = 'as-buy-more-bar__step';
        if (index === 0) step.classList.add('as-buy-more-bar__step--start');
        if (index === this.tiers.length - 1) step.classList.add('as-buy-more-bar__step--end');
        step.style.left = pct + '%';
        step.dataset.tierCount = String(tier.count || 0);

        const iconKey = tier.icon && ICONS[tier.icon] ? tier.icon : index === 0 ? 'start' : 'box';
        const label = tier.label || '';
        const sublabel = tier.sublabel || '';

        step.innerHTML =
          '<span class="as-buy-more-bar__step-dot">' + ICONS[iconKey] + '</span>' +
          (label ? '<span class="as-buy-more-bar__step-label">' + this.escape(label) + '</span>' : '') +
          (sublabel ? '<span class="as-buy-more-bar__step-sublabel">' + this.escape(sublabel) + '</span>' : '');

        this.stepsEl.appendChild(step);
      });
    }

    escape(str) {
      return String(str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    loadQualifyingIds() {
      if (this._qualifyingIdsLoaded || !this.collectionHandle) {
        return Promise.resolve();
      }

      const ids = new Set(this.qualifyingIds);
      let page = 1;

      const fetchPage = () =>
        fetch(
          '/collections/' +
            encodeURIComponent(this.collectionHandle) +
            '/products.json?limit=250&page=' +
            page,
          { credentials: 'same-origin' }
        )
          .then((r) => (r.ok ? r.json() : null))
          .then((data) => {
            if (!data) return;
            const products = Array.isArray(data.products) ? data.products : [];
            products.forEach((product) => {
              if (product && product.id != null) ids.add(product.id);
            });
            if (products.length >= 250) {
              page += 1;
              return fetchPage();
            }
          })
          .then(() => {
            this.qualifyingIds = Array.from(ids);
            this._qualifyingIdsLoaded = true;
          })
          .catch(() => {
            this._qualifyingIdsLoaded = true;
          });

      return fetchPage();
    }

    refresh() {
      const runRefresh = () =>
        fetch('/cart.js', { credentials: 'same-origin' })
          .then((r) => (r.ok ? r.json() : null))
          .then((cart) => {
            if (!cart) return;
            this.cartItemCount = cart.item_count || 0;
            const items = Array.isArray(cart.items) ? cart.items : [];
            let count = 0;
            if (this.restrictToCollection && (this.qualifyingIds.length || this.collectionHandle)) {
              items.forEach((item) => {
                const pid = item.product_id;
                if (this.qualifyingIds.some((q) => q == pid)) {
                  count += item.quantity || 0;
                }
              });
            } else {
              count = this.cartItemCount;
            }
            this.currentCount = count;
            this.update();
          })
          .catch(() => {
            /* noop */
          });

      if (this.restrictToCollection && this.collectionHandle && !this._qualifyingIdsLoaded) {
        return this.loadQualifyingIds().then(runRefresh);
      }

      return runRefresh();
    }

    update() {
      if (!this.tiers.length) {
        this.hide();
        return;
      }

      if (this.isHiddenByFilter()) {
        this.hide();
        return;
      }

      if (getDismissed() && this.isFixedBar) {
        this.hide();
        return;
      }

      const count = this.currentCount;

      if (this.requireQualifying && this.restrictToCollection && this.qualifyingIds.length && count === 0) {
        this.hide();
        return;
      }

      if (this.hideOnEmpty && this.cartItemCount === 0) {
        this.hide();
        return;
      }
      const maxTier = this.tiers[this.tiers.length - 1].count || 1;

      let currentTier = this.tiers[0];
      let currentIndex = 0;
      let nextTier = null;
      for (let i = 0; i < this.tiers.length; i += 1) {
        if (count >= (this.tiers[i].count || 0)) {
          currentTier = this.tiers[i];
          currentIndex = i;
          nextTier = this.tiers[i + 1] || null;
        }
      }

      const posOf = (tier) => (maxTier === 0 ? 0 : ((tier.count || 0) / maxTier) * 100);
      let progressPct;
      if (!nextTier) {
        progressPct = 100;
      } else {
        const currentPos = posOf(currentTier);
        const nextPos = posOf(nextTier);
        const span = Math.max(1, (nextTier.count || 0) - (currentTier.count || 0));
        const within = Math.min(1, Math.max(0, (count - (currentTier.count || 0)) / span));
        progressPct = currentPos + within * (nextPos - currentPos);
      }
      progressPct = Math.min(100, Math.max(0, progressPct));
      if (this.progressEl) this.progressEl.style.width = progressPct + '%';

      if (this.stepsEl) {
        this.stepsEl.querySelectorAll('.as-buy-more-bar__step').forEach((el) => {
          const tierCount = parseInt(el.dataset.tierCount, 10) || 0;
          el.classList.toggle('is-reached', count >= tierCount);
        });
      }

      let message = '';
      if (!nextTier) {
        message = format(this.messages.unlocked, {
          count: count,
          current_label: currentTier.label || '',
        });
      } else if (count === 0) {
        message = format(this.messages.empty, {
          next_count: nextTier.count,
          next_label: nextTier.label || '',
        });
      } else {
        const itemsNeeded = Math.max(0, nextTier.count - count);
        message = format(this.messages.progress, {
          count: count,
          items_needed: itemsNeeded,
          next_count: nextTier.count,
          next_label: nextTier.label || '',
        });
      }

      if (this.messageEl) this.messageEl.innerHTML = message;

      if (!nextTier && this.hideWhenUnlocked) {
        this.hide();
        return;
      }

      this.show();
    }

    show() {
      if (this.element.classList.contains('is-visible')) return;
      this.element.classList.add('is-visible');
      this.element.setAttribute('aria-hidden', 'false');
      if (this.isFixedBar) {
        document.body.classList.add('as-buy-more-bar-visible');
      }
    }

    hide() {
      this.element.classList.remove('is-visible');
      this.element.setAttribute('aria-hidden', 'true');
      if (this.isFixedBar) {
        document.body.classList.remove('as-buy-more-bar-visible');
      }
    }

    dismiss() {
      setDismissed(true);
      document.querySelectorAll('[data-buy-more-bar]').forEach((node) => {
        if (node.classList.contains('as-buy-more-bar--drawer')) return;
        node.classList.remove('is-visible');
        node.setAttribute('aria-hidden', 'true');
      });
      document.body.classList.remove('as-buy-more-bar-visible');
    }
  }

  function initAll() {
    document.querySelectorAll('[data-buy-more-bar]').forEach((el) => {
      if (el.dataset.bmbInitialized === '1') return;
      el.dataset.bmbInitialized = '1';
      new BuyMoreBar(el);
    });
  }

  function scheduleInitAll() {
    setTimeout(initAll, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
